import { animationStyles } from "@components/buttons/common/AnimatedDash"
import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { smallcapsBold14Styles } from "@constants/typography"
import { getContentfulImageAlt } from "@utils/altText"
import { MobileAndTabletOnly } from "@utils/MediaQuery"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  width: 100%;
  cursor: pointer;
  position: relative;
  padding-bottom: 24px;
`

const GatsbyLink = styled(Link)<any>`
  ${({ to }) => (!to.length ? "pointer-events: none" : "cursor: pointer")};
  ${animationStyles}
`

const ImageWrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  ${ImageHelperContainer} {
    padding: 24px;
    width: 100%;
    max-height: 100px;
    background-color: ${colors.backgroundGray};

    @media ${breakpoints.laptop} {
      &:hover {
        background-color: ${colors.backgroundGrayHover};
      }
    }
  }
`

const Content = styled.div`
  display: flex;
  width: 100%;
  padding: 0 10%;
  flex-direction: row;
  align-items: center;
  background: transparent;
  position: absolute;
  z-index: 999;
  top: calc(50% - 18px);
  left: 0;
`

const Title = styled.div`
  ${smallcapsBold14Styles}
  color: #fff;
`

interface VisualLinkProps {
  className?: string
  image: any
  imageTitle?: string
  link: string
  onClick?: () => void
  title: string
}

const MobileVisualLink = (props: VisualLinkProps) => {
  return props.image ? (
    <MobileAndTabletOnly>
      <GatsbyLink to={props.link || ""}>
        <Container className={props.className} onClick={props.onClick}>
          <ImageWrapper>
            <ImageHelper
              alt={getContentfulImageAlt(props.imageTitle)}
              src={props.image.file.url}
              title={props.imageTitle}
            />
          </ImageWrapper>
          <Content>
            <Title>{props.title}</Title>
          </Content>
        </Container>
      </GatsbyLink>
    </MobileAndTabletOnly>
  ) : null
}

export default MobileVisualLink
